import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import { StrategyConfigurationGuard } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel/StrategyConfigurationGuard'
import { type MappedStrategyQuestionnaire } from 'modules/performance_process/hooks/useMappedQuestionnaires'

import { SectionWeightsList } from './SectionWeightsList'
import { SectionWeightsProgress } from './SectionWeightsProgress'

type Props = {
  strategy: PerformanceReviewerStrategiesStrategyEnum
  questionnaire: MappedStrategyQuestionnaire
  navigateToStrategyWeight: (strategy: PerformanceReviewerStrategiesStrategyEnum) => void
}

export const QuestionnaireWeightsPanel: React.FC<Props> = ({
  strategy,
  questionnaire,
  navigateToStrategyWeight,
}) => {
  return (
    <Box gap="s24">
      <SectionWeightsProgress strategy={strategy} questionnaire={questionnaire} />
      <StrategyConfigurationGuard
        strategy={strategy}
        navigateToStrategyWeight={() => navigateToStrategyWeight(strategy)}
      >
        <SectionWeightsList strategy={strategy} questionnaire={questionnaire} />
      </StrategyConfigurationGuard>
    </Box>
  )
}
